import React, { useState } from 'react';
import {
  Box,
  styled,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@invision/ui';
import { useTranslation } from '@invision/core';

const CopyrightContainer = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(3),
  color: 'hsla(0, 0%, 100%, 0.63)',

  '& .copyright-text, & .copyright-link': {
    '&::before': {
      display: 'inline-block',
      margin: `0 ${theme.spacing(1)}`,
      content: '"●"',
      color: 'hsla(0, 0%, 100%, 0.63)',
      cursor: 'default'
    },

    '&:first-child': {
      '&::before': {
        content: '""',
        margin: 0
      }
    }
  },

  '& .copyright-text': {
    color: 'hsla(0, 0%, 100%, 0.63)'
  },

  '& .copyright-link': {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    cursor: 'pointer',

    '&:hover, &:visited, &:active': {
      textDecoration: 'underline'
    }
  }
}));

interface CopyrightFooterProps {
  version?: string;
}

export function CopyrightFooter({ version }: CopyrightFooterProps) {
  const { t } = useTranslation();
  const [showLegalDialog, setShowLegalDialog] = useState(false);

  function openLegalDisclaimer() {
    setShowLegalDialog(true);
  }

  function closeLegalDisclaimer() {
    setShowLegalDialog(false);
  }

  return (
    <>
      <CopyrightContainer>
        <Typography variant="caption" className="copyright-text">
          {t(
            'Copyright © 2016 CSG Systems International, Inc. and/or its affiliates ("CSG International").'
          )}
        </Typography>
        <Typography variant="caption" className="copyright-text">
          {t('All rights reserved')}
        </Typography>
        {version && (
          <Typography variant="caption" className="copyright-text">
            v{version}
          </Typography>
        )}
        <Typography
          variant="caption"
          className="copyright-link"
          onClick={openLegalDisclaimer}
        >
          {t('Legal')}
        </Typography>
      </CopyrightContainer>

      <Dialog
        open={showLegalDialog}
        onClose={closeLegalDisclaimer}
        maxWidth="md"
        fullWidth
        title={t('Legal')}
      >
        <DialogContent>
          <Box sx={{ p: 2 }}>
            <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>
              {t(
                "THIS SOFTWARE AND RELATED INFORMATION IS CONFIDENTIAL AND PROPRIETARY TO CSG AND MAY NOT BE DISCLOSED, COPIED, MODIFIED, OR OTHERWISE USED EXCEPT IN ACCORDANCE WITH THE AGREEMENT(S) WITH CSG THAT GRANT THE USER ACCESS TO THIS APPLICATION. THIS APPLICATION AND RELATED INFORMATION IS PROTECTED BY INTERNATIONAL COPYRIGHT LAWS AND ANY UNAUTHORIZED USE THEREOF MAY VIOLATE COPYRIGHT, TRADEMARK, AND OTHER LAWS. ANY UNAUTHORIZED USE OF THIS SOFTWARE AND/OR INFORMATION WILL AUTOMATICALLY TERMINATE YOUR COMPANY'S RIGHT TO USE THIS SOFTWARE AND/OR INFORMATION. ALL THIRD PARTY TRADEMARKS, SERVICE MARKS, AND/OR PRODUCT NAMES SHOWN HEREIN ARE THE PROPERTY OF THEIR RESPECTIVE OWNERS, AND ALL RIGHTS THEREIN ARE RESERVED."
              )}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeLegalDisclaimer} color="primary">
            {t('Done')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
